const getters = {
  skinType: (state) => state.api.skinType,
  token: (state) => state.user.token,
  workFlowToken: (state) => state.workFlowUser.token,
  accountId: (state) => state.user.accountId,
  mark: (state) => state.user.mark,
  userName: (state) => state.user.name,
  projectList: (state) => state.projects.projectList,
  selectProject: (state) => state.projects.selectProject,
  selectPds: (state) => state.projects.selectPds,
  selectNode: (state) => state.projects.selectNode,
  treeDta: (state) => state['business/CommonService'].treeDta,
  projectListTree: (state) => state.projects.projectListTree,
  selectProjectChild: (state) => state.projects.selectProjectChild,
  roleMapInfo: (state) => state.systemManage.role,
  organizeMapInfo: (state) => state.systemManage.organize,
  dutyMapInfo: (state) => state.systemManage.duty,
  authorizeMenuList: (state) => state.systemManage.authorizeMenu,
  roleTypeMapInfo: (state) => state.systemManage.roleTypeMapInfo,
  certificateMapInfo: (state) => state.systemManage.certificateMapInfo,
  unitInfo: (state) => state.systemManage.unitInfo,
  userInfo: (state) => state.user.userInfo
}
export default getters
